import { useMutation } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { getSessionNode } from '@/shared/bridge';
import { fromRawLogin } from '@/shared/data-mappers';
import type { LoginInput } from '@/shared/data-types';

/**
 * 로그인 mutation — 순수 BE 호출 owner. wire envelope 합성은 inline (toRaw 매퍼 폐지 정책),
 * 응답 → FE 도메인 변환만 `fromRawLogin` 으로 격리.
 *
 * side effect (token store 저장, navigate, 분기 redirect) 는 caller 책임 (features/login-form).
 * entity 가 다른 도메인(store/routing)을 알지 않도록 SRP 보존.
 */
export function useLoginMutation() {
  const api = useApiAppLegacy();

  return useMutation({
    mutationFn: (input: LoginInput) =>
      api.auth
        .login({
          account: { loginId: input.id, password: input.password },
          session: getSessionNode(),
        })
        .then(fromRawLogin),
  });
}
